// extracted by mini-css-extract-plugin
module.exports = {"comparisonPeriodSelectorContainer":"styles_comparisonPeriodSelectorContainer__m-dT-","comparisonPeriodSelector":"styles_comparisonPeriodSelector__1tSi_"};